module.exports = __webpack_public_path__ + "media/images/helpbox_top-e472d328a2c7135c511c5ed01e6db70e.png";